import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";

import {
  BG_JOB_STATUS,
  orchestratorConstants,
  storeConstants,
} from "../../../../constants";
import {
  calculateBarWidth,
  formatedDateTime,
  getResetInventoryColumns,
} from "../../../../shared/utility";
import CustomBodyModal from "../../../../shared/components/modal/CustomBodyModal";
import { ProgressBar, DataTableComponent } from "../../../../shared/components";
import ConfirmationModal from "../../../Inventory/Items/ConfirmationModal/ConfirmationModal";

const ResetStatusModals = ({
  currentStore,
  showViewStatusModal,
  toggleViewStatusModal,
  storeMiscData,
  dfCancelOrchestrator,
  disableCancelResetConfirmationButtons,
  getStoreMiscData,
}) => {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [columns, setColumns] = useState([]);
  const [cancelResetProgress, setCancelResetProgress] = useState(null);
  let numOfRenders = useRef(0);
  const [gridState, setGridState] = useState({
    pageSize: 5,
    pageIndex: 0,
    sortBy: [],
  });

  const handleViewStatus = (status) => {
    setSelectedStatus(status);
  };
  const handleCancelResetProgress = (status) => {
    setCancelResetProgress(status);
  };

  const toggleConfirmationModal = () => {
    setCancelResetProgress(null);
  };
  const handleCloseDetailModal = () => {
    setSelectedStatus(null);
  };
  const handleCancelResetProgressSubmit = () => {
    const dataToSend = {
      id: cancelResetProgress?.id,
      storeId: currentStore?.id,
      orchestrator: orchestratorConstants.UPDATE_INVENTORY_PRESETS,
    };
    dfCancelOrchestrator(dataToSend);
    setCancelResetProgress(null);
  };
  useEffect(() => {
    if (showViewStatusModal) {
      getStoreMiscData(
        currentStore.id,
        storeConstants.BG_JOB_RESET_INVENTORY_WITH_SHOPIFY
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showViewStatusModal]);
  useEffect(() => {
    setColumns(
      getResetInventoryColumns({
        handleViewStatus: handleViewStatus,
        handleCancelResetProgress,
      })
    );
  }, []);

  const selectedStoreMiscData = selectedStatus?.miscData;

  return (
    <>
      <CustomBodyModal
        title="Reset Shopify Status"
        show={showViewStatusModal}
        onHide={toggleViewStatusModal}
        size="xl"
      >
        <Row className="m-0 p-0 w-100">
          <DataTableComponent
            resizableColumns={false}
            responsive={false}
            className="editable-table"
            columns={columns}
            data={storeMiscData}
            key={numOfRenders.current}
            total={storeMiscData?.length || 0}
            gridState={gridState}
            setGridState={setGridState}
          />
        </Row>
      </CustomBodyModal>

      {selectedStatus && (
        <CustomBodyModal
          title="Reset Shopify Details"
          show={!!selectedStatus}
          onHide={handleCloseDetailModal}
          size="md"
        >
          <Row>
            <Col>
              <p className="my-1 fw-bold">Progress</p>
              <ProgressBar
                min={0}
                max={100}
                current={selectedStoreMiscData?.progressPercentage || 0}
                percentage={calculateBarWidth(
                  100,
                  selectedStoreMiscData?.progressPercentage || 0
                )}
                label={`${selectedStoreMiscData?.progressPercentage || 0}%`}
                barWrapper={true}
              />

              <div className="d-flex flex-column my-4 gap-2">
                <p>
                  <span className="fw-bold">Status:</span>{" "}
                  {selectedStoreMiscData?.status || "N/A"}
                </p>
                <p>
                  <span className="fw-bold">Started at:</span>{" "}
                  {selectedStoreMiscData?.startedAt
                    ? formatedDateTime(selectedStoreMiscData.startedAt)
                    : "N/A"}
                </p>

                {selectedStoreMiscData?.completedAt && (
                  <p>
                    <span className="fw-bold">Completed at:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.completedAt)}
                  </p>
                )}

                {selectedStoreMiscData?.scheduleTime &&
                  selectedStoreMiscData?.status === BG_JOB_STATUS.PAUSED && (
                    <p>
                      <span className="fw-bold">Schedule Time:</span>{" "}
                      {formatedDateTime(selectedStoreMiscData.scheduleTime)}
                    </p>
                  )}

                {selectedStoreMiscData?.lastResumedAt && (
                  <p>
                    <span className="fw-bold">Last Resumed at:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.lastResumedAt)}
                  </p>
                )}

                {selectedStoreMiscData?.lastPausedAt && (
                  <p>
                    <span className="fw-bold">Last Paused at:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.lastPausedAt)}
                  </p>
                )}

                {selectedStoreMiscData?.terminatedAt && (
                  <p>
                    <span className="fw-bold">Terminated at:</span>{" "}
                    {formatedDateTime(selectedStoreMiscData.terminatedAt)}
                  </p>
                )}

                <p>
                  <span className="fw-bold">Total Inventory Count:</span>{" "}
                  {selectedStoreMiscData?.totalInventoryCount ?? "N/A"}
                </p>
              </div>
            </Col>
          </Row>
        </CustomBodyModal>
      )}
      <ConfirmationModal
        isConfirmationModal={cancelResetProgress}
        toggleConfirmationModal={toggleConfirmationModal}
        message="Are you sure want to cancel this reset progress?"
        handleNoButtonClick={toggleConfirmationModal}
        handleYesButtonClick={handleCancelResetProgressSubmit}
        isLoading={disableCancelResetConfirmationButtons}
      />
    </>
  );
};

export default ResetStatusModals;
